(function () {
  const syntax=/\b(?:AND|OR|NOT)\b|[":()]|(?:^|\s)-\S/;
  const finishes=/^(?:white|black|grey|gray|oak|walnut|blonde|blond|anthracite|brown|silver|chrome|brass|nickel|gold|bronze|copper)$/i;
  const aliases={gray:'grey',blond:'blonde',doors:'door',handles:'handle',hinges:'hinge'};
  function text(value) {
    const query=String(value||'').trim();
    if(syntax.test(query))return query;
    return query.replace(/\bpre[\s-]?finished\b/gi,'fully finished').replace(/\bprefinish\b/gi,'fully finished').replace(/\s+/g,' ');
  }
  function query(value) {
    const clean=text(value);
    if(syntax.test(clean))return clean;
    const words=clean.split(' ');
    if(!words.some(word=>finishes.test(word)))return clean;
    if(words.some(word=>!/^[-\p{L}\p{N}]+$/u.test(word)))return clean;
    return words.filter(word=>!/^(?:a|an|the|for|with|and|of|in)$/i.test(word)).map(word=>{
      const term=aliases[word.toLowerCase()]||word;
      if(/\p{L}/u.test(term)&&/\d/.test(term))return 'variants.sku:'+term+'*';
      if(/^\d+$/.test(term))return 'variants.title:'+term+'*';
      return 'title:'+term+(finishes.test(term)?'':'*');
    }).join(' ');
  }
  function display(value) {
    const clean=String(value||'');
    if(!/^(?:(?:title|variants\.sku|variants\.title):[-\p{L}\p{N}]+\*?(?:\s+|$))+$/u.test(clean))return clean;
    return clean.replace(/(?:title|variants\.sku|variants\.title):/g,'').replace(/\*/g,'');
  }
  function searchForm(form) {
    if(!form||!form.action)return false;
    try{return /\/search\/?$/.test(new URL(form.action,location.href).pathname);}catch(error){return false;}
  }
  window.D2FSearchQuery=query;
  window.D2FSearchText=text;
  window.D2FSearchDisplay=display;
  document.addEventListener('formdata',function(event){
    if(!searchForm(event.target))return;
    const value=event.formData.get('q');
    if(typeof value==='string')event.formData.set('q',query(value));
  },true);
  document.addEventListener('click',function(event){
    const link=event.target.closest&&event.target.closest('.predictive-search a[href*="/search"]');
    if(!link)return;
    let url;
    try{url=new URL(link.href,location.href);}catch(error){return;}
    if(url.origin!==location.origin||!/\/search\/?$/.test(url.pathname))return;
    const value=url.searchParams.get('q');
    if(value)url.searchParams.set('q',query(value));
    link.href=url.pathname+url.search;
  });
  function initialise() {
    document.querySelectorAll('input[type="search"][name="q"]').forEach(input=>{input.value=display(input.value);});
    const url=new URL(location.href);
    if(!/\/search\/?$/.test(url.pathname)||url.searchParams.has('view'))return;
    const value=url.searchParams.get('q');
    if(!value)return;
    const precise=query(value);
    if(precise!==value){url.searchParams.set('q',precise);location.replace(url.pathname+url.search);return;}
    document.title=document.title.replace(value,display(value));
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialise,{once:true});
  else initialise();
})();
